import React from 'react';
import { connect } from 'react-redux';
import { FiltersWrapper } from './FiltersContainer.styled';
import PillRadioPicker, { IOption } from './PillRadioPicker/PillRadioPicker';
import { navigation_geo_select_geo, navigation_load_menu, navigation_select_channel } from '../../redux/reducers/navigationSlice';
import { IRoot } from '../../helpers/hooks/useTreePattern';

function mapStateToProps(state, ownProps) {
   return {
      selectedChannel: state.navigation.selectedChannel,
      selectedGeography: state.navigation.selectedGeography,
      channels: state.navigation.channels,
      geographies: state.navigation.geographies,
      compareCountries: state.navigation.compareCountries,
      selectedCompareCountriesTopic: state.navigation.selectedCompareCountriesTopic
      // hasPremiumRole: state.auth.hasPremiumForecast
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      selectGeography: (geography, id) => {
         dispatch(navigation_geo_select_geo(geography));
         dispatch(navigation_load_menu(id));
      },
      selectChannel: (channel, _, isMobile) => {
         const params = {
            channel: channel,
            isMobile: isMobile
         };

         dispatch(navigation_select_channel(params));
      }
   };
};

interface IFilters {
   selectedChannel: string;
   selectedGeography: string;
   channels: any[];
   geographies: any[];
   compareCountries: any[];
   selectedCompareCountriesTopic: any;
   selectGeography: any;
   selectChannel: any;
   // hasPremiumRole: boolean;
}

const Filters: React.FC<IFilters> = props => {
   const {
      selectedChannel,
      selectedGeography,
      channels,
      geographies,
      compareCountries,
      selectedCompareCountriesTopic,
      selectGeography,
      selectChannel
      // hasPremiumRole
   } = props;

   const compareCountryChannel = {
      TopicName: 'Compare Countries',
      Collections: ['']
   };

   const channelsWithCompareCountries = channels.concat(compareCountryChannel);

   let selectedChannelValue;
   if (selectedChannel === 'Compare Countries') {
      if (selectedCompareCountriesTopic) {
         selectedChannelValue = 'Compare Countries: ' + selectedCompareCountriesTopic;
      } else {
         selectedChannelValue = 'Compare Countries';
      }
   } else {
      selectedChannelValue = selectedChannel;
   }

   const compareCountriesWithAll = [...compareCountries];
   compareCountriesWithAll.unshift({ TopicName: 'All' });

   const channelFilter: IRoot<IOption> = {
      key: 'Channel',
      children: channelsWithCompareCountries.map(channel => ({
         key: channel.TopicName,
         parent: 'Channel',
         value: {
            name: channel.TopicName
            // subname: channel.Collection && channel.Collections.length > 0 ? `(${channel.Collections.length})` : null,
         },
         children:
            channel.TopicName === 'Compare Countries'
               ? compareCountriesWithAll.map(country => ({
                    key: 'Compare Countries: ' + country.TopicName,
                    parent: 'Compare Countries',
                    value: {
                       name: 'Compare Countries: ' + country.TopicName
                       // subname: country.Collection && country.Collections.length > 0 ? `(${country.Collections.length})` : null,
                    }
                 }))
               : null
      }))
   };

   const geographyFilter: IRoot<IOption> = {
      key: 'Geography',
      children: geographies.map(geography => ({
         key: geography.Name,
         value: {
            name: geography.Name,
            // subname: geography.Regions.length > 0 ? `(${geography.Regions.length})` : null,
            value: geography.GeoId
         },
         parent: 'Geography',
         children: geography.Regions.map(region => ({
            key: region.Name,
            value: {
               name: region.Name,
               value: region.GeoId
            },
            parent: geography.Name
         }))
      }))
   };

   const handleSelectChannel = channel => {
      selectChannel(channel, false);
      window.iiAna('track', 'Forecasts-Channel-Selected', {
         channel: channel
         // hasPremiumRole: hasPremiumRole
      });
   };

   const handleSelectGeography = (geography, geoId) => {
      selectGeography(geography, geoId);
      window.iiAna('track', 'Forecasts-Geography-Selected', {
         geography: geography
         // hasPremiumRole: hasPremiumRole
      });
   };

   return (
      <FiltersWrapper flexDirection='row' justifyContent='start' spaceBetween={8}>
         <PillRadioPicker
            label='Geography'
            options={geographyFilter}
            selectedValue={selectedGeography}
            callback={handleSelectGeography}
            nonLeafOptionsSelectable={false}
         />
         <PillRadioPicker
            label='Channel'
            options={channelFilter}
            selectedValue={selectedChannelValue}
            callback={handleSelectChannel}
            nonLeafOptionsSelectable={false}
         />
      </FiltersWrapper>
   );
};

export default connect(mapStateToProps, mapDispatchToProps)(Filters);
